import { SET_TOKEN, RESET } from "../actions/auth"

const initialState = {
  token: null
}

const handleSetToken = (state, token) => ({
  ...state,
  token
})

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case RESET:
      return initialState;
    case SET_TOKEN:
      return handleSetToken(state, payload)
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/auth.js